import React, { useEffect, useMemo } from 'react'
import { Col, Divider, Form, Row } from 'antd'
import PropTypes from 'prop-types'

import {
  FormButtons,
  FormSelect,
  FormTreeSelect,
} from '../../../common/components/sections'
import { StyledPaddingTopCol } from '../../../common/components/styled'
import { PERMISSIONS } from '../../../common/constants'
import { useFormDirty } from '../../../common/hooks'
import { optionPropType, treeOptionPropType } from '../../../common/prop-types'

import { brandCurationTaskPropType } from '../../prop-types'

import { brandCurationTaskEditorFormInitialValues } from './initial-values'

const BrandCurationTaskEditorForm = ({
  brandCurationTask,
  cuisineTypeOptions,
  mainLocationTypeOptions,
  additionalLocationTypeOptions,
  isLoading,
  isDisabled,
  onSubmit,
}) => {
  const [form] = Form.useForm()
  const { isDirty, setToDirty, resetForm } = useFormDirty(form)
  const initialValues = useMemo(
    () => brandCurationTaskEditorFormInitialValues(brandCurationTask),
    [brandCurationTask],
  )

  useEffect(() => {
    resetForm()
  }, [initialValues, resetForm])

  return (
    <Form
      form={form}
      initialValues={initialValues}
      name="editBrandCurationTask"
      onFinish={onSubmit}
      autoComplete="off"
      onFieldsChange={setToDirty}
    >
      <Row gutter={[16]}>
        <Col span={6}>
          <FormSelect
            label="Location Type"
            labelAbove
            showSearch
            name="mainLocationTypeId"
            options={mainLocationTypeOptions}
            placeholder="Select Main Location Type..."
            disabled={isDisabled}
          />
        </Col>
        <FormSelect
          name="additionalLocationTypeIds"
          label="Additional Location Types"
          options={additionalLocationTypeOptions}
          labelAbove
          showSearch
          placeholder="Select Additional Location Type..."
          mode="multiple"
          disabled={isDisabled}
        />
        <Col span={6}>
          <FormTreeSelect
            label="Cuisine Type"
            labelAbove
            showSearch
            name="cuisineTypeId"
            treeData={cuisineTypeOptions}
            placeholder="Select Cuisine Type..."
            disabled={isDisabled}
          />
        </Col>
        <StyledPaddingTopCol span={6}>
          <FormButtons
            permissions={[PERMISSIONS.BRAND_CURATION_TASK.UPDATE]}
            isDisabled={!isDirty}
            isLoading={isLoading}
            onReset={resetForm}
          />
        </StyledPaddingTopCol>
      </Row>
      <Divider />
    </Form>
  )
}

BrandCurationTaskEditorForm.propTypes = {
  brandCurationTask: brandCurationTaskPropType.isRequired,
  cuisineTypeOptions: PropTypes.arrayOf(treeOptionPropType),
  mainLocationTypeOptions: PropTypes.arrayOf(optionPropType),
  additionalLocationTypeOptions: PropTypes.arrayOf(optionPropType),
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

BrandCurationTaskEditorForm.defaultProps = {
  cuisineTypeOptions: [],
  mainLocationTypeOptions: [],
  additionalLocationTypeOptions: [],
  isLoading: false,
  isDisabled: false,
}

export default BrandCurationTaskEditorForm
